<template v-once>
  <img src="@/assets/icons/deepintent_icon.svg" alt="deepintent icon">
</template>

<script>
export default {
  name: "DeepIntent",
};
</script>

<style scoped>
</style>
